/**
 * Say "Đăng nhập bằng shop" on Shopify's Shop login button.
 *
 * `{{ shop | login_button }}` renders <shop-login-button>, whose label lives in
 * an open shadow root as a single text node followed by the Shop wordmark as an
 * SVG - "Sign in with" + logo. Only that text node is rewritten, so the wordmark
 * and the button's own styling are untouched, and the accessible name becomes
 * "Đăng nhập bằng Shop" through the SVG's existing <title>.
 *
 * The component belongs to Shopify and re-renders on its own, so the rewrite is
 * re-applied from a MutationObserver rather than run once. It matches the exact
 * English string and nothing else: if Shopify changes the wording or the markup,
 * this quietly does nothing instead of mangling the button.
 *
 * The real fix is to publish Vietnamese as the store's language, which makes
 * Shopify render its own translation here. Remove this file when that happens.
 */
(function () {
  var FROM = 'Sign in with';
  var TO = 'Đăng nhập bằng';
  var seen = new WeakSet();

  function relabel(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      // An exact match only. The wordmark's own <title>Shop</title> and any
      // other copy Shopify puts in there are left alone.
      if (node.nodeValue && node.nodeValue.trim() === FROM) {
        node.nodeValue = node.nodeValue.replace(FROM, TO);
      }
    }
  }

  function watch(host) {
    if (!host || seen.has(host)) return;
    var root = host.shadowRoot;
    if (!root) return;   // not attached yet; the document observer comes back
    seen.add(host);
    relabel(root);
    // Rewriting a text node fires this observer once more, and that pass finds
    // nothing left matching FROM, so it settles rather than looping.
    new MutationObserver(function () { relabel(root); })
      .observe(root, {childList: true, subtree: true, characterData: true});
  }

  function scan() {
    var hosts = document.querySelectorAll('shop-login-button');
    for (var i = 0; i < hosts.length; i++) watch(hosts[i]);
    return hosts.length;
  }

  function start() {
    scan();
    // The button is created when a drawer opens, and its shadow root is attached
    // a tick after the element itself, so both the arrival and the attachment
    // have to be caught.
    new MutationObserver(scan).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
    var tries = 0;
    var timer = setInterval(function () {
      scan();
      if (++tries > 40) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {once: true});
  } else {
    start();
  }
})();
